<template>

  <b-card
    class="mb-1"
    style="margin:0;border:1px solid #c9c9c9;"
  >
    <b-card-header
      header-tag="header" 
      role="tab"
      block 
      @click="visibleBody = !visibleBody"
      style="padding:0; cursor: pointer;"
    >
      <span class="mr-5">NATALES</span>
      <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
    </b-card-header>
    <b-collapse 
      v-model="visibleBody" 
      id="collapse-4"
    >
      <b-card-body>

        <fieldset :disabled="onlyView">
          <div>

            <b-row class="my-2">
              <b-col class="col-6 d-flex align-items-center">
                <label> Tipo de Parto: </label>
                <v-select
                  class="col-8"
                  placeholder="Seleccione una o mas opciones"
                  :options="tipoPartoOpts"
                  :reduce="option => option"
                  label="text"
                  v-model="natal.tipoParto"
                  :disabled="onlyView"
                />
              </b-col>

              <b-col class="col-6 d-flex align-items-center">
                <label class="mr-1">Edad gestacional (semanas): </label>
                <b-form-input
                  class="col-3" 
                  type="number" 
                  v-model="natal.edadGestacional"
    
                />
              </b-col>
            </b-row>

            <b-row class="my-1 d-flex align-items-center">
              <label class="col-4"> Complicaciones al nacimiento: </label>

              <b-form-checkbox 
                switch 
                v-model="natal.complicaciones.active"
                class="col-2"

              >
                {{ natal.complicaciones.active ? 'Si' : 'No' }}
              </b-form-checkbox>
              
              <b-form-input 
                v-if="natal.complicaciones.active"
                v-model="natal.complicaciones.descripcion"
                class="col-6"
                placeholder="Describa..."

              />
              
            </b-row>


            <b-row>
              <label class="col-4"> Sufrimiento fetal: </label>
              <b-form-checkbox 
                switch 
                v-model="natal.sufrimiento.active"
                class="col-2"

              >
                {{ natal.sufrimiento.active ? 'Si' : 'No' }}
              </b-form-checkbox>
              
              <b-form-input 
                v-if="natal.sufrimiento.active"
                v-model="natal.sufrimiento.descripcion"
                placeholder="Describa..."
                class="col-6"

              />
            </b-row>


            <b-row class="my-1 d-flex align-items-center">
              <label class="col-4"> LLoro al nacer: </label>
              <b-form-checkbox 
                switch 
                v-model="natal.lloro"
                class="col-2"

              >
                {{ natal.lloro ? 'Si' : 'No' }}
              </b-form-checkbox>
            </b-row>

            
            <b-row class="my-1 d-flex align-items-center">

              <label class="col-4"> Perímetro Torácico : </label>
              <b-form-input 
                v-model="natal.perimetroToraxico" 
                class="col-2"
                type="number"

              />

              <label class="col-4"> Perímetro cefálico: </label>
              <b-form-input 
                v-model="natal.perimetroEncefalico" 
                class="col-2"
                type="number"

              />

              <label class="col-4"> Perímetro abdominal: </label>
              <b-form-input 
                v-model="natal.perimetroAbdominal" 
                class="col-2"
                type="number"

              />
            </b-row>
            
            <b-row class="my-1 d-flex align-items-center">
              <label class="col-4"> Peso(kg): </label>
              <b-form-input 
                v-model="natal.peso" 
                class="col-2"
                type="number"

              />
              <label class="col-4"> Talla(cm): </label>
              <b-form-input 
                v-model="natal.talla" 
                class="col-2"
                type="number"

              />
            </b-row>

            <b-row class="my-1 d-flex align-items-center">
              <label class="col-2"> Test APGAR: </label>
              <b-form-input 
                v-model="natal.testApgar.value1" 
                placeholder="Valor 1"
                class="col-2"
                type="number"

              />           
              <b-form-input 
                v-model="natal.testApgar.value2" 
                placeholder="Valor 2"
                class="col-2"
                type="number"

              />
            </b-row>
          
          </div>

         
        </fieldset>

        

        
      </b-card-body>
    </b-collapse>

  </b-card>

  
</template>

<script>
import { mapState } from 'vuex';
import vSelect from "vue-select";

export default {

  name: "Natales",

  props: {
    onlyView: {
      type: Boolean,
      default: false
    }
  },

  components: {
    vSelect
  },

  data() {
    return {
      visibleBody: false,

      natal:{
        tipoParto: { value: "natural", text: "Natural" },
        edadGestacional:0,

        complicaciones:{
          active: false,
          descripcion: ''
        },

        sufrimiento:{
          active: false,
          descripcion: ''
        },

        perimetroEncefalico: 0,
        perimetroAbdominal:0,
        perimetroToraxico: 0,

        peso:null,
        talla:null,

        testApgar:{
          value1:null,
          value2:null
        },

      },

      // psicomotriz:{
      //   cabeza: false,
      //   sentarse: false,
      //   comunicacion: false,
      //   caminar:false
      // },

      exploracion:{
        osteotendinosos:null

      },

      exploracionChecked:[],
      exploracionItems:[],

      tipoPartoOpts: [
        { value: "natural", text: "Natural" },
        { value: "cesarea", text: "Cesarea" },
      ],

      exploracionOpts:[
        { value: "reflejos_osteotendinosos", text: "Reflejos osteotendinosos" },
        { value: "reflejos_arcaicos",        text: "Reflejos arcaicos o primitivos" },
        { value: "reflejos_glabelar",        text: "Reflejos glabelar" },
        { value: "reflejos_de_buscaqueda",   text: "Reflejos de búsqueda" },
        { value: "reflejos_de_succión",      text: "Reflejos de succión" },
        { value: "reflejos_de_presion",      text: "Reflejos de presion" },
        { value: "reflejos_tonicos",         text: "Reflejos tónico asimétrico del cuello" },
        { value: "reflejos_de_extensión",    text: "Reflejos de extensión cruzada" },
        { value: "reflejos_de_colocación",   text: "Reflejos de colocación" },
        { value: "reflejos_de_marcha",       text: "Reflejo de la marcha" },
      ],

      reflejosOpts: [
        { value: "presente", text: "Presente" },
        { value: "ausente",  text: "Ausente (Deficit neurológico)" },
      ]

    }

  },


  methods: {
    
    resetNatal(){
      this.natal = {
        tipoParto: { value: "natural", text: "Natural" },
        edadGestacional:0,

        complicaciones:{
          active: false,
          descripcion: ''
        },

        sufrimiento:{
          active: false,
          descripcion: ''
        },

        perimetroEncefalico: 0,
        perimetroAbdominal:0,
        perimetroToraxico: 0,

        peso:null,
        talla:null,

        testApgar:{
          value1:null,
          value2:null
        },

        psicoCabeza: false,
        psicoSentarse: false,
        psicoComunicacion: false,
        psicoCaminar:false
      }
    }
  },


  computed: {
    ...mapState({
      stSemPediatrica: state => state.atencionCita.semiologias?.semPediatrica,
      stSemiologiaView: state => state.atencionMedica.dataAtencion.semiologiaView
    }),
  },

  watch: {

    stSemPediatrica:{
      immediate: true,
      deep: true,

      handler(newVal) {
        if(this.onlyView) return;
        
        // const tokenAtencion = this.$route.params.token;
        // if(!tokenAtencion) return;

        if (newVal.natal) {
          this.natal = newVal.natal;
        }
      }
    },



    stSemiologiaView:{
      immediate: true,
      handler(newValue){
        if(!this.onlyView) return;

        this.resetNatal();

        if (newValue?.natal) this.natal = newValue.natal;        
      }
    },


    natal:{
      deep: true,
      handler(newValue) {
        if(this.onlyView) return;
        this.$store.commit("setNatales", newValue);
      }
    },

  }


}
</script>
